export const DELETE_GROUP = "DELETE_GROUP";
export const DELETE_GROUP_SUCCESS = "DELETE_GROUP_SUCCESS";
export const DELETE_GROUP_FAILED = "DELETE_GROUP_FAILED";
export const DELETE_GROUP_RESET = "DELETE_GROUP_RESET";

export const deleteGroup = (payload) => {
  return {
    type: DELETE_GROUP,
    payload,
  };
};

export const deleteGroupSuccess = (payload) => {
  return {
    type: DELETE_GROUP_SUCCESS,
    payload,
  };
};

export const deleteGroupFailed = (payload) => {
  return {
    type: DELETE_GROUP_FAILED,
    lockedUserMessage:
      "A previous network change is still in process. Please try again later",
    payload,
  };
};

export const resetGroupState = () => {
  return {
    type: DELETE_GROUP_RESET,
  };
};
